import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import HrDashboard from "./hr/HrDashboard";
import LeftNav from "../../component/leftSideNav/LeftNav";
import TopBar from "../../component/topBar/TopBar";
import { locationActions } from "../../redux/actions";
import { isSuperAdmin } from "../../constant/helper/helper";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentUser, isAuthenticated } = useSelector(
    (state) => state.auth
  );

  const loginType = localStorage.loginType;
  const locationModuleName = localStorage.locationName;
  const moduleName = localStorage.moduleType;
  useEffect(() => {
    setTimeout(() => {
      if (isAuthenticated && isSuperAdmin(currentUser)) {
        navigate(
          `/dashboard/${currentUser.workerFirstName}/${currentUser.workerDepartment}`
        );
      } else if (
        isAuthenticated &&
        typeof locationModuleName !== "undefined" &&
        typeof moduleName !== "undefined"
      ) {
        navigate(
          `/dashboard/${currentUser.workerFirstName}/${currentUser.workerDepartment}`
        );
      } else if (isAuthenticated) {
        navigate("/auth/select-project");
      }
    }, 1000);
  }, [locationModuleName, moduleName]);

  useEffect(() => {
    dispatch(locationActions.clearLocationErrors());
    dispatch(locationActions.clearLocationResult());
    dispatch(locationActions.getAllLocation(loginType));
    return () => {
      dispatch(locationActions.clearLocationErrors());
      dispatch(locationActions.clearLocationResult());
    };
  }, []);

  return (
    <div className="wrapper">
      <LeftNav />
      <div className="content-page">
        <TopBar
          title={
            currentUser.workerDepartment !== "SUPER ADMIN" &&
            currentUser.workerDegination !== "SUPER ADMIN"
              ? locationModuleName + " / " + moduleName
              : "Dashboard"
          }
        />
        <div className="content">
          <HrDashboard loginType={loginType} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
